import * as React from 'react';
import { SecurityListHeaderColumn, SecurityListColumn } from '../../../../../common/security-list';
import { OnHoverTooltip } from '../../../../../common';
import IconSVG from '../../../../../../styles/svg-icons';
import { Final } from '../../../bid-placement/Final';
import { BwicPosition } from '../../../../../../types/bwic/BwicPosition';
import { biddingUtils } from '../../../../../../utils';
import { BwicBase } from '../../../../../../types/bwic/BwicBase';
import { AllToAllArgeementRequiredActionBlocker } from '../../../../../agreements/AllToAllArgeementRequiredActionBlocker';

const ColumnHeader = () => {
    return (
        <SecurityListHeaderColumn className='data-list-cell-xxs padding-l-0 text-center'>
            <OnHoverTooltip overlay="Final. Bid will be marked as final, but you will be allowed to improve afterward.">
                <IconSVG name="final" width={16} height={16} />
            </OnHoverTooltip>
        </SecurityListHeaderColumn>
    );
}

export const final = {
    columnName: 'final',
    renderHeader: function () {
        return <ColumnHeader key={this.columnName} />;
    },
    renderBody: function (position: BwicPosition, context: { biddingControlsVisible: boolean, enabled: boolean, bwic: BwicBase }) {
        const { biddingControlsVisible, enabled } = context;
        const currentBid = biddingUtils.getCurrentBid(position.bids);

        return (
            <SecurityListColumn key={this.columnName} className="data-list-cell-xxs padding-l-0 text-center">
                {biddingControlsVisible &&
                    <AllToAllArgeementRequiredActionBlocker disabled={!context.bwic.isAllToAll}>
                        {
                            blocked => (
                                <Final
                                    currentFinal={Boolean(currentBid?.final)}
                                    currentPass={Boolean(currentBid?.pass)}
                                    positionId={position.id}
                                    disabled={!enabled || blocked}
                                />
                            )
                        }
                    </AllToAllArgeementRequiredActionBlocker>}
                {!biddingControlsVisible && Boolean(currentBid?.final) && <IconSVG name="final" width={16} height={16} />}
            </SecurityListColumn>
        );
    }
};
